module.exports = __webpack_public_path__ + "konto.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/konto.svg
// module id = 115
// module chunks = 0